import { useMemo } from "react"
import { DataLayer } from "../services/DataLayer"

export const useDataLayer = () => useMemo(() => new DataLayer(), [])
